import { render, staticRenderFns } from "./ResizeSizeInput.vue?vue&type=template&id=fbcc3884&scoped=true"
import script from "./ResizeSizeInput.vue?vue&type=script&lang=js"
export * from "./ResizeSizeInput.vue?vue&type=script&lang=js"
import style0 from "./ResizeSizeInput.vue?vue&type=style&index=0&id=fbcc3884&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcc3884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbcc3884')) {
      api.createRecord('fbcc3884', component.options)
    } else {
      api.reload('fbcc3884', component.options)
    }
    module.hot.accept("./ResizeSizeInput.vue?vue&type=template&id=fbcc3884&scoped=true", function () {
      api.rerender('fbcc3884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/ResizeSizeInput.vue"
export default component.exports